import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Area,
} from "recharts";

interface FunnelDataItem {
  name: string;
  value: number;
  dotted: number;
}

interface SalesFunnelChartProps {
  data: FunnelDataItem[];
}

// export const dummyData: FunnelDataItem[] = [
//   { name: "Jan", value: 20000, dotted: 11000 },
//   { name: "Feb", value: 10000, dotted: 15000 },
//   { name: "March", value: 30000, dotted: 24000 },
//   { name: "April", value: 15000, dotted: 18000 },
//   { name: "May", value: 24000, dotted: 19000 },
//   { name: "June", value: 22000, dotted: 26000 },
//   { name: "July", value: 30000, dotted: 29000 },
// ];

const CustomLineChartTooltip = ({
  active,
  payload,
}: {
  active?: boolean;
  payload?: any[];
}) => {
  if (active && payload?.length) {
    return (
      <div className="bg-[#00000066] px-3 py-2 rounded text-white text-sm">
        {payload[0].value.toLocaleString()}
      </div>
    );
  }
  return null;
};

const FinancialProjection: React.FC<SalesFunnelChartProps> = ({ data }) => {
  return (
    <div className="p-6 bg-white rounded-2xl shadow-[0_0_54px_0_rgba(0,0,0,0.05)] max-h-[400px]">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-[14px]">
          <p className="font-semibold text-base text-neutral-500 leading-5">
            Financial Projection
          </p>
          <p className="text-neutral-300 text-sm leading-5">
            Monthly Revenue Projection
          </p>
        </div>
        <div className="flex gap-4 text-[13px] leading-4">
          
          <div className="md:flex items-center gap-1 text-neutral-500 hidden">
            <span className="w-[6px] h-[6px] rounded-full bg-neutral-500" />
            <p>Academic Year : 2026-2027</p>
          </div>

         
          <div className="flex items-center gap-1 text-neutral-500">
            <span className="w-[6px] h-[6px] rounded-full bg-primary-100" />
            <p>Last year</p>
          </div>
        </div>
      </div>
      {/* Chart */}
      <div className="h-[290px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{ top: 10, right: 0, left: -20, bottom: 0 }}
          >
            {/* Gradient */}
            <defs>
              <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#00000066" />
                <stop offset="100%" stopColor="#000000" />
              </linearGradient>
            </defs>

            {/* Axes */}
            <XAxis
              dataKey="name"
              tickLine={false}
              axisLine={false}
              tick={{ fill: "#666666", fontSize: 13 }}
              padding={{ left: 20 }}
            />
            <YAxis
              domain={[0, "dataMax"]}
              tickFormatter={(v) => `${v / 1000}K`}
              tickLine={false}
              axisLine={false}
              padding={{ top: 30 }}
              tick={{ fill: "#666666", fontSize: 13 }}
            />

            {/* Tooltip */}
            <Tooltip
              content={<CustomLineChartTooltip />}
              cursor={{ stroke: "#1A1A1A", strokeDasharray: "3 3" }}
            />

            {/* Gradient Area */}
            <Area
              type="monotone"
              dataKey="value"
              stroke="none"
              fill="url(#areaGradient)"
              fillOpacity={1}
            />

            {/* Dotted Wave (independent) */}
            <Line
              type="monotone"
              dataKey="dotted"
              stroke="var(--Neutral-neutral-50, #1A1A1A)"
              strokeOpacity={0.3}
              strokeWidth={1}
              strokeDasharray="4 4"
              dot={false}
            />

            {/* Main Line */}
            <Line
              type="monotone"
              dataKey="value"
              stroke="#1A1A1A"
              strokeWidth={1}
              dot={false}
              activeDot={{
                r: 5,
                fill: "#00000066",
                stroke: "white",
                strokeWidth: 1,
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default FinancialProjection;
